// Window event the LawyerApp shell listens to for re-fetching /lawyer/dashboard.
export const DASHBOARD_RELOAD_EVENT = "advoset:lawyer-new-booking";
export const requestDashboardReload = () => window.dispatchEvent(new Event(DASHBOARD_RELOAD_EVENT));

export const AVAILABILITY_REFRESH_EVENT = "advoset:lawyer-availability-refresh";
export const requestAvailabilityRefresh = () => window.dispatchEvent(new Event(AVAILABILITY_REFRESH_EVENT));
